import axios from 'axios';
import { useEffect, useState } from 'react';
import { getAgreementsForUser, getId } from './UserService';

export async function createDataSharingAgreement(result: any) {
	return axios
		.post(
			`/api/datasharingagreement`,
			{
				tspProviderId: result.telematicSolutionProviderId,
				fleetCompanyId: result.id,
				fleetIdentifier: result.fleetIdentifier,
				signerName: '',
			},
			{ headers: { 'Content-Type': 'application/json' } }
		)
		.then(
			async res => res.status,
			err => Promise.reject(err)
		);
}

export async function updateDataSharingAgreement(signature: string, state: any) {
	const userId = await getId().then(res => res.data);
	const agreements = (await getAgreementsForUser(userId).then(res => res.data.items)) as any[];
	const dataSharingAgreementId = state === undefined
		? agreements[agreements.length - 1].id.toString()
		: agreements.filter(v => v.fleetCompanyId === state.fleetCompanyId)[0].id.toString();

	const now = new Date();
	const date = new Date(now.getTime()).toISOString();

	return axios
		.patch(
			`/api/datasharingagreement/signed`,
			{
				agreementId: dataSharingAgreementId,
				signature: signature,
				signedDate: date,
			},
			{ headers: { 'Content-Type': 'application/json' } }
		)
		.then(
			async res => res.status,
			err => Promise.reject(err)
		);
}

export async function getDataSharingAgreementPreview(url: string) {
	return axios.get(url).then(
		async res => res.data,
		err => Promise.reject(err)
	);
}

export async function getDataSharingAgreementPreviewUrl(dsaId?: string, isPreview = true) {
	const userId = await getId().then(res => res.data);
	const agreements = (await getAgreementsForUser(userId).then(res => res.data.items)) as any[];
	let id = '';
	let blob = '';
	if (dsaId) {
		id = dsaId;
		const selectedAgreement = agreements.filter(v => v.id.toString() === dsaId)[0];
		blob = selectedAgreement.documentBlobReference;
	} else {
		const agts = agreements[agreements.length - 1];
		id = agts.id;
		blob = agts.documentBlobReference;
	}
	const preview = isPreview ? '/preview' : '';
	return `/api/datasharingagreement/${id}/${blob}${preview}`;
}

export const usePdfViewer = (dsaId?: string, isPreview = true) => {
	const [url, setUrl] = useState('');
	const [isComplete, setIsComplete] = useState(false);
	useEffect(() => {
		const urlFetch = async () =>
			getDataSharingAgreementPreviewUrl(dsaId, isPreview).then(
				res => {
					setUrl(res);
					setIsComplete(true);
				},
				err => Promise.reject(err)
			);
		urlFetch();
   }, [dsaId, isPreview]);
	return { pdfViewer: { data: url, isComplete: isComplete } };
};

export const DataSharingAgreementService = {
	createDataSharingAgreement,
	updateDataSharingAgreement,
	getDataSharingAgreementPreview,
	getDataSharingAgreementPreviewUrl,
};
